(() => {
  const element = document.getElementById('mc-ivory-map');
  if (!element) return;
  const map = JSON.parse(element.textContent);
  function match(url) {
    if (!url) return;
    const name = url.split('?')[0].split('/').pop();
    return map[name] || map[name.replace(/_\d+x\d*(?=\.[^.]+$)/, '')];
  }
  function update(img) {
    if (!img.matches?.('img, source')) return;
    const replacement = match(img.getAttribute('src')) || match((img.getAttribute('srcset') || '').split(/\s/)[0]);
    if (!replacement) return;
    if (img.tagName === 'IMG') img.setAttribute('src', replacement.src);
    img.setAttribute('srcset', replacement.srcset);
    if (img.tagName === 'SOURCE' && img.hasAttribute('type')) img.setAttribute('type', 'image/webp');
  }
  function scan(root) { update(root); root.querySelectorAll?.('img,source').forEach(update); }
  scan(document);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') update(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset']});
})();

/* Mamacita: phone sticky bar (updated 27 Oct 2026).
   - Products with a Size option: before a size is picked it reads "Choose your size · £xx" and scrolls to the sizes.
   - Once a size is picked it reads "Add to cart · £xx" and adds to the bag (personalisation is still validated),
     or, for a sold-out size, "Notify me when back in stock", which opens the REZ back-in-stock sign-up.
   - Products without a Size option (caps, eye masks, candles...) read "Add to cart · £xx" straight away.
   - When REZ shows its "Preorder" button for the chosen size, the bar reads "Preorder · £xx" and presses REZ's button,
     so pre-orders always go through REZ. On desktop the theme's own sticky button is redirected to REZ the same way.
   - Hidden while the main Add to cart button is on screen, while the sizes are on screen (before a size is picked)
     and over the footer, so there are never two buttons at once.
   - The theme rebuilds the sticky bar, size picker and buy buttons whenever a size changes, so this re-attaches itself. */
(() => {
  const mq = window.matchMedia('(max-width: 699px)');
  const state = {
    chosen: new URLSearchParams(window.location.search).has('variant'),
    variants: null,
    buyVisible: false,
    pickerVisible: false,
    footerVisible: false,
    observers: [],
    current: null,
    soldOut: false,
    preorder: false
  };

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' }).format(cents / 100);

  const productPath = window.location.pathname.match(/\/products\/[^/?#]+/);
  if (productPath) {
    fetch(productPath[0] + '.js').then((r) => r.json()).then((p) => { state.variants = p.variants || null; state.current?.render(); }).catch(() => {});
  }

  const attach = () => {
    const bar = document.querySelector('product-sticky-bar');
    if (!bar || bar.querySelector('.mc-sticky-choose')) return;
    const formId = bar.getAttribute('form');
    const form = document.forms[formId];
    if (!form) return;
    /* Only a "Size" option needs choosing first. Colour, slogan or no options: the selected one is fine, so go straight to Add to cart. */
    const sizeField = Array.from(document.querySelectorAll('input[type="radio"][form="' + formId + '"]'))
      .map((input) => input.closest('fieldset'))
      .find((fieldset) => fieldset && /size/i.test(fieldset.querySelector('legend')?.textContent || ''));
    const picker = sizeField ? sizeField.closest('variant-picker') || sizeField : null;
    if (!sizeField) state.chosen = true;
    const mainBuy = Array.from(document.querySelectorAll('buy-buttons')).find((el) => !bar.contains(el) && (el.getAttribute('form') === formId || form.contains(el)));
    const footer = document.querySelector('.shopify-section--footer');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button mc-sticky-choose';
    bar.appendChild(button);

    /* REZ's visible "Preorder" button in the main buy buttons, when the chosen size is on pre-order. */
    const preorderButton = () => Array.from(document.querySelectorAll('.rez-preorder-btn')).find((el) => !bar.contains(el) && el.offsetParent !== null);
    const themeButton = bar.querySelector('buy-buttons button[type="submit"]');
    const themeLabel = themeButton ? themeButton.textContent : '';
    bar.addEventListener('click', (event) => {
      const rez = preorderButton();
      if (!rez || !themeButton || !themeButton.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      rez.click();
    }, true);

    const render = () => {
      const id = String(form.elements.namedItem('id')?.value || '');
      const variant = state.variants ? state.variants.find((v) => String(v.id) === id) : null;
      const fallback = (bar.querySelector('sale-price')?.textContent || '').replace(/sale price/i, '').trim();
      const price = variant ? money(variant.price) : fallback;
      const soldOut = !!(state.chosen && variant && !variant.available);
      state.soldOut = soldOut;
      const preorder = !!(state.chosen && preorderButton());
      state.preorder = preorder;
      if (themeButton) {
        const label = preorder ? 'Preorder' : themeLabel;
        if (themeButton.textContent !== label) themeButton.textContent = label;
      }
      const text = soldOut ? 'Notify me when back in stock' : (preorder ? 'Preorder' : state.chosen ? 'Add to cart' : 'Choose your size') + (price ? ' · ' + price : '');
      if (button.textContent !== text) button.textContent = text; /* only touch the DOM when it changes */
      if (button.disabled) button.disabled = false;
    };
    const update = () => {
      const show = mq.matches && !state.buyVisible && !state.footerVisible && !(!state.chosen && state.pickerVisible);
      bar.classList.toggle('mc-early', show);
    };
    button.addEventListener('click', () => {
      if (!state.chosen && picker) { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (state.preorder) {
        /* Pre-order size: let REZ add it, so the pre-order details go with the order. */
        const rez = preorderButton();
        if (rez) { rez.click(); return; }
      }
      if (state.soldOut) {
        /* Sold-out size: open the REZ "Notify me when back in stock" sign-up. */
        const rez = Array.from(document.querySelectorAll('.rez-stock-notification-button')).find((el) => !bar.contains(el));
        if (rez) rez.click();
        else (picker || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });

    state.observers.forEach((o) => o.disconnect());
    state.observers = [];
    const watch = (el, key) => {
      if (!el) { state[key] = false; return; }
      const o = new IntersectionObserver((entries) => { state[key] = entries[entries.length - 1].isIntersecting; update(); });
      o.observe(el);
      state.observers.push(o);
    };
    watch(mainBuy, 'buyVisible');
    watch(picker, 'pickerVisible');
    watch(footer, 'footerVisible');

    state.current = { render, update, formId };
    render(); update();
  };

  /* A size was picked (event delegation survives the theme re-rendering the picker).
     "click" also covers tapping the size that is already ticked, which fires no "change". */
  const picked = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio' || !state.current) return;
    if (target.getAttribute('form') !== state.current.formId) return;
    const legend = target.closest('fieldset')?.querySelector('legend')?.textContent || '';
    if (/size/i.test(legend)) state.chosen = true;
    state.current.render(); state.current.update();
    setTimeout(() => state.current?.render(), 300);
    setTimeout(() => state.current?.render(), 1200); /* REZ swaps its buttons in a moment after the theme */
  };
  document.addEventListener('change', picked);
  document.addEventListener('click', picked);

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; attach(); state.current?.render(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });
  mq.addEventListener?.('change', () => state.current?.update());

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();
